'use client';

import type { Profile } from '@/actions/get-profile/types';
import { createContext, useContext } from 'react';

interface SessionContextValue {
  session: Profile | null;
  isLoading: boolean;
  error: Error | null;
  deleteSession: () => Promise<void>;
}

export const SessionContext = createContext<SessionContextValue>({
  session: null,
  isLoading: true,
  error: null,
  deleteSession: async () => {}
});

export function useSessionContext() {
  const context = useContext(SessionContext);
  return context;
}
